export default __webpack_public_path__ + "static/media/ic-animals-cow.16c7f384.svg";